import { apiGet, apiPost, apiRequest } from './client';

export type ManageableType = 'MX' | 'TXT' | 'CNAME' | 'SRV';

export interface DnsRecord {
  id: string;
  type: string;
  name: string;
  content: string;
  priority?: number;
  ttl: number;
  proxied?: boolean;
}

export interface DnsRecordInput {
  type: ManageableType;
  name: string;
  content: string;
  priority?: number;
}

export interface DnsRecordsStatus {
  success: boolean;
  domain: string;
  records: DnsRecord[];
  /** null when Cloudflare's routing status could not be read — do not treat as "off". */
  forwardingEnabled: boolean | null;
  manageableTypes: ManageableType[];
}

export async function getDnsRecords(domain: string): Promise<DnsRecordsStatus> {
  return apiGet<DnsRecordsStatus>(`/api/admin/dns-records?domain=${encodeURIComponent(domain)}`);
}

/**
 * Write records. When the domain still uses niftee forwarding and the set
 * includes MX, the server replies 409 until `disableForwarding` is passed —
 * the two cannot both own the domain's MX.
 */
export async function createDnsRecords(
  domain: string,
  records: DnsRecordInput[],
  disableForwarding = false
): Promise<{ success: boolean; created: DnsRecord[]; forwardingPaused: boolean }> {
  return apiPost('/api/admin/dns-records', { domain, records, disableForwarding });
}

export async function deleteDnsRecord(
  domain: string,
  recordId: string
): Promise<{ success: boolean }> {
  return apiRequest(
    `/api/admin/dns-records?domain=${encodeURIComponent(domain)}&recordId=${encodeURIComponent(recordId)}`,
    { method: 'DELETE' }
  );
}
